import { FC } from 'react';
import { GetAvatar } from 'Utils/generateThumbnail';
import Tooltip from 'Components/UI/Tooltip';
import { ContainerTooltip, MentionContainer } from './styles';
import { IUserData } from 'Data/interfaces/User/IUserData';
import { SelectMentionUserGroupIdEnum } from '../MentionListUser';

const userMentionGroupLabel: Record<SelectMentionUserGroupIdEnum, string> = {
  [SelectMentionUserGroupIdEnum.followers]: 'seguidores',
  [SelectMentionUserGroupIdEnum.assigneds]: 'responsáveis',
};

interface IMentionUserComponentRender {
  isGroup?: boolean;
  groupId?: SelectMentionUserGroupIdEnum | null;
  user?: IUserData;
}

const MentionUserComponentRender: FC<IMentionUserComponentRender> = ({
  isGroup,
  groupId,
  user,
}) => {
  if (isGroup) {
    return (
      <MentionContainer>
        <span className="identifier">
          @{userMentionGroupLabel[groupId as SelectMentionUserGroupIdEnum]}
        </span>
      </MentionContainer>
    );
  }

  return (
    <Tooltip
      placement="top"
      overlay={(
        <ContainerTooltip>
          <GetAvatar
            name={user?.Nome || ''}
            shape="circle"
            size={24}
            src={user?.OriginalImageUrl}
            thumbSrc={user?.ThumbnailImageUrl}
          />
          <div className="contentTooltip">
            <span className="name">{user?.Nome}</span>
            <span className="email">{user?.Email}</span>
          </div>
        </ContainerTooltip>
      )}
    >
      <MentionContainer>
        <span className="identifier">@{user?.Nome}</span>
      </MentionContainer>
    </Tooltip>
  );
};

export default MentionUserComponentRender;
